import React from 'react';
import PropType from 'prop-types';

function SelectionBox({rect}) {
  const getStyles = () => {
    if (!rect) return {};
    return {
      left: rect.x,
      top: rect.y,
      width: rect.width,
      height: rect.height,
    };
  };

  return (
    <div
      className="selection-box"
      style={{
        position: 'absolute',
        background: 'blue',
        opacity: 0.3,
        border: '1px dashed grey',
        cursor: 'default',
        zIndex: 9000,
        ...getStyles(),
      }}
    />
  );
}

SelectionBox.propTypes = {
  rect: PropType.any.isRequired,
};

export default SelectionBox;
